export const APP_CENTER_CHANGED_EVENT = 'nextos:app-center-changed';

export function announceAppCenterChanged(): void {
  window.dispatchEvent(new Event(APP_CENTER_CHANGED_EVENT));
}

export function subscribeAppCenterChanged(listener: () => void): () => void {
  window.addEventListener(APP_CENTER_CHANGED_EVENT, listener);
  return () => window.removeEventListener(APP_CENTER_CHANGED_EVENT, listener);
}
